export type SpotifyAccountInfo = {
  id?: string; // spotify username
  email?: string;
  images?: {
    url?: string;
  }[];
  displayName?: string;
};

export type FetchSpotifyAccountResponse = {
  status?: number;
} & SpotifyAccountInfo;

async function fetchSpotifyAccount({
  userId,
}: {
  userId: number;
}): Promise<FetchSpotifyAccountResponse> {
  const response = await fetch(
    `/api/proxy/v3/users/${userId}/spotify/account`,
    {
      method: 'GET',
      credentials: 'same-origin',
    }
  );
  if (response.ok) {
    return response.json();
  }

  return {
    status: response.status,
  };
}

export { fetchSpotifyAccount };
